import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layouts/layout";
import Projectlist from "./pages/ProjectList";
import ProjectDetail from "./pages/ProjectDetail";
import Projectadd from "./pages/Projectadd";
import BackgroundBox1 from "./pages/PatientDetail";
import QuestionnaireBuilder from "./pages/question_multi";
import PatientDetail from "./pages/PatientDetail";
import SchedulePage from "./pages/Process_schedule";
import PatientQuestionnaire from "./pages/patient/PatientQuestionnaire";
import ClientManagement from "./pages/client-management/ClientManagement";
import ClientEdit from "./pages/client-management/ClientEdit";
import QuestionnaireList from "./pages/questionnaire-management/QuestionnaireList";
import QuestionnaireEdit from "./pages/questionnaire-management/QuestionnaireEdit";
import PatientManagementList from "./pages/patient-management/PatientList";
import PatientEdit from "./pages/patient-management/PatientEdit";
import ReportsPage from "./pages/reports/ReportsPage";
import { withAuth } from "./auth/withAuth";
import StaffRoutes from "./auth/StaffRoutes";
import RequirePatientRole from "./auth/RequirePatientRole";
import HomeRoute from "./pages/HomeRoute";
import ForbiddenPage from "./pages/ForbiddenPage";

// Single auth check for layout (Keycloak); role-specific gates are on routes below.
const ProtectedLayout = withAuth(Layout);

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={
            <ProtectedLayout>
              <Routes>
                <Route path="/403" element={<ForbiddenPage />} />
                <Route path="/" element={<HomeRoute />} />
                <Route
                  path="/patient/questionnaires/:executionId/:scheduleId"
                  element={
                    <RequirePatientRole>
                      <PatientQuestionnaire />
                    </RequirePatientRole>
                  }
                />

                <Route element={<StaffRoutes />}>
                  <Route path="/project" element={<Projectlist />} />
                  <Route path="/client-management" element={<ClientManagement />} />
                  <Route path="/client-management/edit/:cid" element={<ClientEdit />} />
                  <Route path="/questionnaire-management" element={<QuestionnaireList />} />
                  <Route path="/questionnaire-management/edit/:qid" element={<QuestionnaireEdit />} />
                  <Route path="/subject-management" element={<PatientManagementList />} />
                  <Route path="/subject-management/edit/:patientId" element={<PatientEdit />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/PatientDetail/:ptiid/:projectid/:procode" element={<PatientDetail />} />
                  <Route path="/project/add" element={<Projectadd />} />
                  <Route path="/project-details/:proid" element={<ProjectDetail />} />
                  <Route path="/BackgroundBox1" element={<BackgroundBox1 />} />
                  <Route path="/AddQuestion/:projectId" element={<QuestionnaireBuilder />} />
                  <Route
                    path="/Process_schedule/:proId/:ptid/:scheduleId/:exeid/:scheddt/:status/:wsize"
                    element={<SchedulePage />}
                  />
                </Route>
              </Routes>
            </ProtectedLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
